import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import { getStrings } from '@/api/language';
import { eventBus } from '@/helpers/eventBus';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE, // set locale
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
  messages: {}
});
const loadedLanguages = []; // our default language that is preloaded

function setI18nLanguage (lang) {
  i18n.locale = lang;
  axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  localStorage.setItem('SITE_LANGUAGE', i18n.locale);
  eventBus.$emit('i18n_locale_modified');
  return lang;
}

export async function loadLanguageAsync (lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      const msgs = await getStrings(lang);
      i18n.setLocaleMessage(msgs.EM_CURR_LANG, msgs.EM_LANG);
      if (lang === msgs.EM_CURR_LANG) {
        loadedLanguages.push(lang);
      }
      return setI18nLanguage(msgs.EM_CURR_LANG);
    }
    return Promise.resolve(setI18nLanguage(lang));
  }
  return Promise.resolve(lang);
}
